<template>
  <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
    <el-form-item label="用户名" prop="username">
      <el-input v-model="ruleForm.username" placeholder="请输入用户名"></el-input>
    </el-form-item>
    <el-form-item label="密码" prop="password">
      <el-input type="password" v-model="ruleForm.password" placeholder="请输入密码" autocomplete="off"></el-input>
    </el-form-item>
    <el-form-item>
      没有账号？
      <el-button type="text" @click="handleRegister">去注册</el-button>
    </el-form-item>
    <el-form-item>
      <el-button @click="cancelForm('ruleForm')">取消</el-button>
      <el-button type="primary" @click="submitForm('ruleForm')">确认</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import Vue from "vue"
import {checkoutWincourseUser} from "@/api/auth/jwt";
import {encryption, getEncryptedString} from "@/wincourse/utils/aesEncrypt";
import {ENCRYPTED_STRING} from "@/wincourse/store/mutation-types";

export default {
  name: "ValidateUser",
  data() {
    return {
      rules: {
        username: [
          {required: true, message: '请输入用户名', trigger: 'blur'},
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'},
        ],
      },
      ruleForm: {},
      encryptedString: {
        key: '',
        iv: '',
      },
    }
  },
  created() {
    this.getEncrypte()
  },
  methods: {
    /**
     * 取消
     */
    cancelForm() {
      this.$emit("cancel")
    },
    /**
     * 提交表单
     * @param formName
     */
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.validateUser()
        } else {
          return false;
        }
      });
    },
    /**
     * 验证用户
     */
    validateUser() {
      let {password} = this.ruleForm
      let {key, iv} = this.encryptedString
      checkoutWincourseUser({
        ...this.ruleForm,
        password: encryption(password, key, iv)
      })
          .then(res => {
           // TODO 验证是否有用户
            if (res != null) {
              this.$emit("validate-ok", {
                ...res.user,
                token: res.token
              })
            }
          })
    },
    /**
     * 引导注册云课时间用户
     */
    handleRegister() {
      this.$confirm('没有账号？注册新账号', '提示', {
        confirmButtonText: '去注册',
        cancelButtonText: '取消',
        type: 'warning'
      })
          .then(() => {
            // 注册新账号
            this.$emit("validate-ok")
          })
          .catch(() => {
            // do something
          });
    },
    //获取密码加密规则
    getEncrypte() {
      let encryptedString = Vue.ls.get(ENCRYPTED_STRING)
      if (encryptedString == null) {
        getEncryptedString()
            .then((data) => {
              this.encryptedString = data
            })
      } else {
        this.encryptedString = encryptedString
      }
    },
  }
}
</script>
